import React from "react";
import Link from "next/link";
import Image from "next/image";
import FooterMenu from "./FooterMenu";
import ReservationButton from "../Header/ReservationButton";

const FooterInfo = ({ dataFooter }) => {
  return (
    <div className="lg:mb-[83px] md:mb-10 mb-5">
      <div className="container">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5 lg:gap-0">
          <div className="flex flex-col items-start justify-center md:items-start md:justify-start lg:col-span-2">
            <div className="sm:w-[350px] w-full flex flex-col items-start">
              <div className="flex flex-col items-center justify-center mb-4 md:items-start md:justify-start md:mb-9">
                <span className="text-[#7B94B0] font-medium leading-normal text-size-13">
                  2000+ villa ile bugüne dek 10.000+ misafir ağırladık.
                </span>
                <span className="sm:text-[1.75rem] text-xl flex items-center md:justify-start justify-center flex-wrap gap-1 font-bold leading-tight tracking--tightest text-[#004798]">
                  Türkiye’nin
                  <span className="text-[#EC6701]"> villa tatiline</span>
                  açılan
                  <span className="font-normal"> yenilikçi platformu</span>
                </span>
              </div>
              <div className="mb-7">
                <ReservationButton dataHeader={dataFooter} />
              </div>
              <div className="flex items-center justify-center gap-3 md:justify-end md:items-end">
                <Link
                  href="https://etbis.eticaret.gov.tr/sitedogrulama/1483078662831626"
                  target="_blank"
                >
                  <Image
                    src="/etbisXcontent.png"
                    width={130}
                    height={132}
                    alt="etbis"
                    className="object-contain h-[106px]"
                  />
                </Link>
                <Link
                  className="block"
                  href="https://www.tursab.org.tr/tr/ddsv"
                  target="_blank"
                >
                  <Image
                    src="/icons/villavagonu-tursab-dds-16753.png"
                    width={290}
                    height={132}
                    alt="tursab"
                    className="object-contain"
                  />
                </Link>
              </div>
            </div>
          </div>
          <FooterMenu dataFooter={dataFooter} />
        </div>
      </div>
    </div>
  );
};

export default FooterInfo;
